import React, { useEffect, useState } from 'react'
import Countdown from '../../components/elements/Countdown';
import CheckBadgeIcon from '../../components/elements/icons/CheckBadgeIcon';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Loader from '../../components/elements/Loader';
import { useDispatch } from 'react-redux';
import { ERROR } from '../../store/types';

const EmailConfirmation = () => {
  const { confirmationCode } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [counted, setCounted] = useState(false);
  const [accountActivated, setAccountActivated] = useState(true);

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        const headers = {
          'Content-Type': 'application/json'
        }

        await axios.get(`${process.env.REACT_APP_BASE_URL}/onboarding/confirm-email/${confirmationCode}?`, { headers })            

        setAccountActivated(true)
        setTimeout(() => {
          navigate('/')
        }, 5000);

      } catch (error) {
          console.log(error)
          dispatch({
              type: ERROR,
              error
          })
          setAccountActivated(false)
      }
    }
    confirmEmail()
    return () => {
      
    };
  }, [confirmationCode, dispatch, navigate]);
  return (
    <div className='w-full bg-vcm-light-purple bg-opacity-10 min-h-screen h-inherit py-12'>
      <div className="w-4/12 mx-auto rounded-[8px] bg-white p-8 transition duration-200">
        <h1 className="font-thin text-primary mb-5 text-opacity-80 tracking-[0.2em] uppercase">vaatia college makurdi</h1>

        <div className='border-b w-full border-gray-300 mt-8 mb-4' />
        
        {!accountActivated ? 
          <div className='flex flex-col items-center justify-center'>
            <Loader />
            <p className="text-sm text-center w-10/12">Hold on a moment, we're confirming your email address and activating your account.
            </p> 
          </div>
          :
          <>
            <div className='flex items-center justify-center text-center'>
                <CheckBadgeIcon className={`text-purple-500 w-10 h-10 mb-4`} />
              </div>
              <h1 className="font-thin text-xs text-center w-full text-primary mb-2 text-opacity-80 tracking-[0.2em] uppercase">thank you</h1>
              <p className='w-full text-center text-sm'>Your account has been activated successfully!</p>

          </>
        }

        <div className='w-full text-center'>
          {counted 
              ? 
                  <p></p>
              :
              <>
                  <p className='py-2 text-gray-400 text-xs mt-2'>Redirecting you to the log in page in <Countdown seconds={5} className='inline text-green-500 font-medium' countdownComplete={()=>{setCounted(true)}} /> seconds
                  </p>
              </>
          }
      </div>

      </div>
    </div>
  )
}

export default EmailConfirmation